import LocationLink from '../../../../components/LocationLink';

export default LocationLink;
